import { FileUploader } from "react-drag-drop-files";
import "./ArtifactPage.css";
import { COMMENT_MAX_LENGTH, TITLE_MAX_LENGTH } from "utils/constants";
import React, { Suspense, lazy, useCallback, useEffect, useRef, useState } from "react";
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    FormControl,
    FormControlLabel,
    IconButton,
    InputLabel,
    LinearProgress,
    MenuItem,
    Select,
    TextField,
    Typography,
    Stack,
    Divider,
    CircularProgress,
} from "@mui/material";
import { ReactComponent as ForwardArrow } from "static/svgs/forwardArrow.svg";
import { ReactComponent as BackwardArrow } from "static/svgs/BackwardArrow.svg";
import { ReactComponent as UploadIcon } from "static/svgs/uploadIcon.svg";
import circle_exclamation from "static/circle_exclamation.png";
import closeIcon from "static/closeIcon.png";
import circlecheck from "static/circlecheck.png"
import { CheckBox } from "@mui/icons-material";
import CheckBoxFN from "components/FutureNavBasedComponents/CheckBox";
import educatorService from "services/educatorService";
import { getColorByTitle, tintRgba } from "utils/componentUtils";
import { skillBasedStyles } from "../AIHelperTool/data/common-data";
import useCurrentLearnerId from "../AIHelperTool/hooks/useCurrentLearnerId";
import AlertBox, { AlertBoxRef } from "components/AlertBox";

const LazyFileUploader = lazy(() => import("./LazyFileUploader"));

interface Credit {
    id: string;
    title: string;
    description?: string;
    evidence_progress_id?: number;
    type?: string;
}
interface SkillItem {
    id: string;
    title: string;
    description?: string;
    credits: Credit[];
    position?: number;
}
interface AddArtifactDialogProps {
    skillsData: any | [];
    id: any;
    localArtifactdata: any,
    open: boolean;
    handleClose: () => void;
    handleAddArtifact: (e: React.MouseEvent<HTMLButtonElement>) => Promise<string>;

    value: File | null;
    title: string;
    desc: string;
    url: string;
    error: string;
    uploadProgress: number;
    types: string;
    group: boolean;
    setTypes: (types: string) => void
    setValue: (file: File | null) => void;
    setFileValueToUpload: (file: File | null) => void;
    setTitle: (title: string) => void;
    setDesc: (desc: string) => void;
    setUrl: (url: string) => void;
    setError: (error: string) => void;
    setGroup: (group: boolean) => void;

    handleChange: (file: File) => void;
    fetchArtifacts: () => Promise<void>;
}

const fileTypes = ["JPG", "PNG", "PDF", "MP4"];
const options = ['Performance-Based Task', 'In-Class Assignment', 'Outside-of-School']

const AddArtifactDialog: React.FC<AddArtifactDialogProps> = ({
    skillsData,
    id,
    localArtifactdata,
    open,
    handleClose,
    handleAddArtifact,

    value,
    title,
    desc,
    url,
    error,
    uploadProgress,
    types,
    group,
    setGroup,
    setTypes,
    setValue,
    setFileValueToUpload,
    setTitle,
    setDesc,
    setUrl,
    setError,

    handleChange,
    fetchArtifacts,
}) => {

    const [attachButton, setAttachButton] = useState<boolean>(false)
    const [continueButton, setcontinueButton] = useState<boolean>(false)
    const [fileURL, setfileURL] = useState<boolean>(false);
    const getCurrentLearnerId = useCurrentLearnerId();

    const [selectedSkillObjects, setSelectedSkillObjects] = useState<any[]>([]);
    // const [pendingSkills, setPendingSkills] = useState<{
    //     add: { skillId?: any; subSkillId: any }[];
    //     remove: { skillId?: any; subSkillId: any }[];
    // }>({
    //     add: [],
    //     remove: [],
    // });
    const [comment, setComment] = useState<string>("");
    const [loadingStatus, setLoadingStatus] =
        useState<"idle" | "pending" | "error" | "success">("success");

    const alertRef = useRef<AlertBoxRef>(null);

    // const getArtifactDetails = async () => {
    //     setLoadingStatus("pending");
    //     // skillsData?.areas.map((skill: any) => {
    //     //     clearAll(skill.title);
    //     // });
    //     let artifactData = await educatorService.getEvidenceDetails(localArtifactdata.current);
    //     if (artifactData) {
    //         setArtifactAreas(artifactData.areas);
    //         setComments(artifactData.comments);
    //         setArtifactDescription(artifactData.description);
    //         setArtifactTitle(artifactData.title);
    //         setArtifactUrl(artifactData.fileUrl);
    //         setLoadingStatus("success");
    //         const fileValue = artifactData.fileUrl.split('/')[artifactData.fileUrl.split('/').length - 1];
    //         const typeValue = fileValue.substring(0, fileValue.indexOf('?'))
    //         setFilet(typeValue.substring(typeValue.lastIndexOf('.') + 1));

    //     }
    //     if (
    //         artifactData?.areas &&
    //         artifactData.areas.length &&
    //         skillsData &&
    //         skillsData.areas
    //     ) {
    //         artifactData.areas.map((artifact: any) => {
    //             selectAll(
    //                 artifact.title,
    //                 artifact.credits.map((a: any) => a.title)
    //             );
    //         });
    //     };
    // }

    // const selectAll = async (sectionTitle: string, buttons: string[]) => {
    //     setChangeColorb((prevState: any) => ({
    //         ...prevState,
    //         [sectionTitle]: buttons,
    //     }));
    // };


    // const removeSkill = async (
    //     skillId: any,
    //     subSkillId: any,
    //     isBulk: boolean = false
    // ) => {
    //     const area = artifactAreas.find((area) => area.id === skillId);
    //     if (!area) return undefined; // Return undefined if the area is not found

    //     const credit = area.credits.find((credit) => credit.id === subSkillId);
    //     if (!credit) return undefined;
    //     let associateSkill = await educatorService.deleteAssociatedSkill(
    //         credit?.evidence_progress_id
    //     );
    //     if (associateSkill) {
    //         if (!isBulk) {
    //             await getArtifactDetails();
    //         }
    //         return true;
    //     }
    // };

    // const changeColor = async (
    //     label: string,
    //     sectionTitle: string,
    //     subSkillId: any,
    //     skillId?: any
    // ) => {
    //     setChangeColorb((prevState: any) => {

    //         const updatedSection = prevState[sectionTitle] || [];
    //         const isSelected = updatedSection?.includes(label);

    //         setPendingSkills((prev) => {
    //             const add = isSelected
    //                 ? prev.add.filter((item) => item.subSkillId !== subSkillId)
    //                 : [...prev.add, { skillId, subSkillId }];
    //             const remove = isSelected
    //                 ? [...prev.remove, { skillId, subSkillId }]
    //                 : prev.remove.filter((item) => item.subSkillId !== subSkillId);
    //             return { add, remove };
    //         });

    //         return {
    //             ...prevState,
    //             [sectionTitle]: isSelected
    //                 ? updatedSection.filter((item: any) => item !== label)
    //                 : [...updatedSection, label],
    //         };
    //     });
    // };
    // const applySkillChanges = async () => {
    //     const addPromises = pendingSkills.add.map(({ subSkillId }) => {
    //         return addSkill(subSkillId);
    //     });

    //     const removePromises = pendingSkills.remove.map(({ skillId, subSkillId }) => {
    //         return removeSkill(skillId, subSkillId);
    //     });

    //     await Promise.all([...addPromises, ...removePromises]);

    //     setPendingSkills({ add: [], remove: [] });
    // };

    const handleContinue = async (e: any) => {
        setLoadingStatus("pending");
        const newError = await handleAddArtifact(e)
        setLoadingStatus("success");
        if (newError) {
            alertRef.current?.open(newError, "error");
        } else {
            setAttachButton(false);
            setcontinueButton(true);
            alertRef.current?.close();
        }
        // skillsData?.areas.map(async (skill: any) => {
        //     clearAll(skill.title);
        // });
    }

    const handleLocalClose = useCallback((e?: any) => {
        handleClose();
        setAttachButton(false);
        setcontinueButton(false);
        setComment('');
        setDesc('');
        setTypes('');
        setUrl('');
        // skillsData?.areas.forEach((skill: any) => {
        //     clearAll(skill.title);
        // });
        // setPendingSkills({ add: [], remove: [] });
        setSelectedSkillObjects([]);
    }, [handleClose, skillsData]);

    const handleSubmitClose = async () => {
        handleClose();
        setAttachButton(false);
        setcontinueButton(false);
        setComment('');
        setTypes('')
        setDesc('');
        setUrl('');
        setSelectedSkillObjects([]);
    }

    // const getBulkAssociationRequestBody = () => {
    //     const requestBody: UpdateBulkSubskillAssociationsRequestBody = {
    //         credit_ids: [],
    //         evidence_progress_ids: [],
    //     };

    //     // Collect all subskill (credit) IDs from selected skill objects
    //     selectedSkillObjects.forEach((skill: any) => {
    //         skill.credits.forEach((credit: any) => {
    //             requestBody.credit_ids.push(credit.id);
    //         });
    //     });

    //     const finalBody: Partial<UpdateBulkSubskillAssociationsRequestBody> = {
    //         ...requestBody,
    //     };

    //     if (requestBody.credit_ids.length === 0) delete finalBody.credit_ids;
    //     if (requestBody.evidence_progress_ids.length === 0) delete finalBody.evidence_progress_ids;

    //     console.log('Bulk association request body:', finalBody);
    //     return finalBody;
    // };

    const handleSubmit = async () => {
        if (comment.trim() !== "") {
            await educatorService.addComment(localArtifactdata.current, comment.trim());
        }
        const selectedSkillIds = selectedSkillObjects.map((skill: any) => skill.id);
        const learnerId = getCurrentLearnerId();
        const formData = new FormData();
        formData.append("learner_id", learnerId as string);
        formData.append("studentSelectedSkills", JSON.stringify(selectedSkillIds));
        await educatorService.updateEvidence(localArtifactdata.current, formData);
        handleSubmitClose();

        // const learnerId = getCurrentLearnerId();
        // const requestBody = getBulkAssociationRequestBody();
        // if (Object.keys(requestBody).length > 0) {
        //     await educatorService.updateBulkSubskillAssociations({
        //         artifactId: localArtifactdata.current,
        //         learnerId,
        //         requestBody,
        //     });
        // }

        await fetchArtifacts();
    }

    useEffect(() => {
        const handleKeyDown = (event: any) => {
            if (event.key === 'Escape') {
                handleLocalClose(event);
            }
        };
        if (open) {
            document.addEventListener('keyup', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keyup', handleKeyDown);
        };
    }, [open, handleLocalClose]);

    return (
        <Dialog
            PaperProps={{
                sx: {
                    minHeight: "314px",
                    minWidth: "428px",
                    padding: "20px",
                    maxWidth:'720px'
                },
            }}
            open={open}
        >
            {loadingStatus === "pending" && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        zIndex: 10,
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  )}
            {/* Third screen */}
            {continueButton && <>
                <Box sx={{ display: "flex", flexDirection: "column", gap: '5px', paddingY: "4px", px: "35px" }}>
                    <Box sx={{ fontWeight: 300, fontSize: "28px" }}>Reflect on your work.</Box>
                    <Divider sx={{ borderColor: '#22333B', mb:'20px'}} />
                    <Typography sx={{ fontSize: '16px', fontWeight: 400, padding: 0, lineHeight: '22px' }}>Your artifact has been added to your profile. Now add a reflection to your artifact.</Typography>
                    <IconButton
                        sx={{ position: "absolute", right: 7, top: 7 }}
                        onClick={(e) => handleLocalClose(e)}
                        onKeyDown={(e) => {
                            if (e.key == 'Escape') {
                                e.preventDefault();
                                handleLocalClose(e)
                            }
                        }}
                    >
                        <img src={closeIcon} height={10} width={10} alt="Close" />
                    </IconButton>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                        <Box sx={{ display: 'flex', flexDirection: 'column', mt: '1px', gap: 1 }}>
                            <TextField
                                size="medium"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                onBlur={() => setComment(comment.trim())}
                                variant="outlined"
                                placeholder="For example: My speech was organized, convincing, and delivered with confidence.                            "
                                multiline
                                maxRows={3}
                                inputProps={{
                                    maxLength: COMMENT_MAX_LENGTH, sx: {
                                        '&::placeholder': {
                                            fontStyle: 'italic',
                                        },
                                    },
                                }}
                                sx={{
                                    backgroundColor: 'rgba(242, 246, 253, 1)',
                                    height: '104.5px',
                                    borderRadius: '8px',

                                    // This targets the input wrapper
                                    '& .MuiInputBase-root': {
                                        height: '100%',
                                        alignItems: 'flex-start',
                                    },

                                    // Remove border
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                    },

                                    // This targets the actual textarea
                                    '& .MuiInputBase-inputMultiline': {
                                        // padding: '12px',      // Optional: control padding
                                        height: '100%',
                                        boxSizing: 'border-box',
                                        overflow: 'auto',
                                    },
                                }}
                            />
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "right" }}>
                            <Typography sx={{ fontSize: "12px", color: "#455459", mt: '6px' }}>
                                {comment.length}/{COMMENT_MAX_LENGTH}
                            </Typography>
                        </Box>
                        <p style={{ fontSize: '16px', fontWeight: '400', lineHeight: '22px', marginBottom: '10px' }}>Select the skills demonstrated during your experience.</p>
                        {skillsData &&
                            skillsData.areas.map((acc: any) => (
                                <div
                                    key={acc.id}
                                    className={`${skillBasedStyles[acc.title] || ""} mb-[10px] rounded-lg border`}
                                >
                                    <div className="flex items-center w-full px-6 h-[50px]">
                                        <CheckBoxFN
                                            className="mr-[15px]"
                                            checked={selectedSkillObjects.some(s => s.id === acc.id)}
                                            onChange={() => {
                                                const isSelected = selectedSkillObjects.some(s => s.id === acc.id);
                                                if (isSelected) {
                                                    setSelectedSkillObjects(prev => {
                                                        const updated = prev.filter(s => s.id !== acc.id);
                                                        console.log('Removed skill, selectedSkillObjects:', updated);
                                                        return updated;
                                                    });
                                                } else {
                                                    setSelectedSkillObjects(prev => {
                                                        const updated = [...prev, acc];
                                                        console.log('Added skill, selectedSkillObjects:', updated);
                                                        return updated;
                                                    });
                                                }
                                            }}
                                        />
                                        <p className="font-semibold -mt-3">
                                            {acc.title}
                                        </p>
                                    </div>
                                    <div className="px-6 pb-4 -mt-5">
                                        <p className="text-xs ml-[41px]">{acc.description}</p>
                                    </div>
                                </div>
                            ))}
                        {/* <p style={{ fontSize: '12px', fontWeight: '400' }}>Need the definitions of the skills and subskills? To learn more go to the skill page.</p> */}
                    </Box>
                </Box>
                <DialogActions>
                    <Button
                        onClick={(e) => handleLocalClose(e)}
                        sx={{
                            maxHeight: "32px",
                            color: "rgba(7, 27, 34, 1)",
                            borderColor: "rgba(7, 27, 34, 1)",
                            borderRadius: '8px',
                            border: '2px solid rgba(7, 27, 34, 1)',
                            backgroundColor: 'rgba(238, 242, 253, 1)',
                            fontWeight: '600',
                            fontSize: '14px',
                            width: '117px',
                            whiteSpace: 'nowrap',
                            mt: '0px',
                            padding: '0px'
                        }}
                    >
                        Skip for now
                    </Button>
                    <Button
                        onClick={() => handleSubmit()}
                        sx={{
                            maxHeight: "32px",
                            color: "rgba(238, 242, 253, 1)",
                            borderColor: "rgba(7, 27, 34, 1)",
                            borderRadius: '8px',
                            border: '2px solid rgba(7, 27, 34, 1)',
                            backgroundColor: 'rgba(7, 27, 34, 1)',
                            fontWeight: '600',
                            fontSize: '14px',
                            width: '168px',
                            whiteSpace: 'nowrap',
                            mt: '0px',
                            padding: '0px'
                        }}
                    >
                        Submit Reflection
                    </Button>
                </DialogActions>
            </>}

            {/* Second Screen */}
            {attachButton && <>
                <AlertBox ref={alertRef} />
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", paddingY: "10px" }}>
                    <Box sx={{ fontWeight: 700, fontSize: "24px" }}>Attach</Box>
                    <Box>
                        <Stack direction="row" spacing={10} alignItems="flex-end">
                            <Box
                                sx={{
                                    position: "relative",
                                    pb: 0, // remove extra padding
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: fileURL ? 600 : 700,
                                        color: "text.primary",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        setfileURL(false);
                                        setUrl('');
                                        setTitle('');
                                        alertRef.current?.close();
                                    }}
                                >
                                    File Upload
                                </Typography>
                                {!fileURL && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            left: 0,
                                            right: 0,
                                            bottom: -2, // align with Divider
                                            height: "2px",
                                            backgroundColor: "#0f1010ff",
                                            zIndex: 1,
                                        }}
                                    />
                                )}
                            </Box>
                            <Box
                                sx={{
                                    position: "relative",
                                    pb: 0, // remove extra padding
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: fileURL ? 700 : 600,
                                        color: "text.primary",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        setfileURL(true);
                                        setValue(null);
                                        setFileValueToUpload(null);
                                        setError('');
                                        setTitle('');
                                        alertRef.current?.close();
                                    }}
                                >
                                    URL
                                </Typography>
                                {fileURL && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            left: 0,
                                            right: 0,
                                            bottom: -2, // align with Divider
                                            height: "2px",
                                            backgroundColor: "#0f1010ff",
                                            zIndex: 1,
                                        }}
                                    />
                                )}
                            </Box>
                        </Stack>
                        <Divider sx={{ mt: 0, height: '1px', backgroundColor: "#A7ADB1", position: "relative", zIndex: 0 }} />
                    </Box>

                    <IconButton
                        sx={{ position: "absolute", right: 7, top: 7 }}
                        onClick={(e) => handleLocalClose(e)}
                        onKeyDown={(e) => {
                            if (e.key == 'Escape') {
                                e.preventDefault();
                                handleLocalClose(e)
                            }
                        }}
                    >
                        <img src={closeIcon} height={10} width={10} alt="Close" />
                    </IconButton>
                </Box>
                {/* {uploadProgress > 0 && (
                <LinearProgress variant="determinate" value={uploadProgress} />
            )} */}
                {fileURL ? <>
                    <Typography sx={{ fontWeight: 400, fontSize: "12px", my: '23px', color: '#22333B' }}>
                        You can provide a link of a Google Drive file.
                    </Typography>
                    <label style={{ fontWeight: 400, fontSize: "12px", display: "block", marginBottom: "6px", color: '#071B22' }}>
                        Enter URL Here
                    </label>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={url}
                        onChange={(e) => {
                            setUrl(e.target.value);
                            alertRef.current?.close();
                        }}
                        placeholder="Google Drive URL*"
                        onBlur={() => setUrl(url.trim())}
                        sx={{ mb: 2, fontWeight: 400, fontSize: "12px", backgroundColor: '#F2F6FD' }}
                        error={!!url && !/^https?:\/\/(drive\.google\.com)\/.+$/.test(url)}
                        helperText={url && !/^https?:\/\/(drive\.google\.com)\/.+$/.test(url) ? "Please enter a valid Google Drive URL" : ""}
                    />
                    {url && /^https?:\/\/(drive\.google\.com)\/.+$/.test(url) && (
                        <Box
                            sx={{
                                display: "flex",
                                height: "auto",
                                flexDirection: "column",
                                paddingY: "20px",
                                gap: "10px",
                            }}
                        >
                            <label>Title</label>
                            <TextField
                                value={title}
                                onChange={(e) => setTitle(e.target.value.slice(0, TITLE_MAX_LENGTH))}
                                onBlur={() => setTitle(title.trim())}
                                size="small"
                                variant="outlined"
                                inputProps={{ maxLength: TITLE_MAX_LENGTH }}
                            />
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography sx={{ fontSize: "12px", color: "#455459" }}>
                                    You can revise this title at any point.
                                </Typography>
                                <Typography sx={{ fontSize: "12px", color: "#455459" }}>
                                    {title.length}/{TITLE_MAX_LENGTH}
                                </Typography>
                            </Box>
                        </Box>
                    )}
                </> : <>
                    <Suspense fallback={<div>Loading uploader...</div>}>
                        <LazyFileUploader
                            handleChange={(file) => {
                                alertRef.current?.close();
                                handleChange(file)
                            }}
                            name="file"
                            label="Drag & Drop or Choose File to upload"
                            types={fileTypes}
                            classes="custom-fileUploader"
                            onTypeError={() => setError("This type of file can't be uploaded. The platform accepts JPEG, PNG, PDF and MP4 file formats.")}
                        >
                            <div className="file-uploader-content" style={{ marginTop: '20px' }}>
                                <span className="custom-icon">
                                    <UploadIcon />
                                </span>
                                {(value == null && error === "") || error.includes('damaged') ? (
                                    <Box sx={{ textAlign: 'center' }}>
                                        <p style={{ fontSize: "16px", fontWeight: 600, marginBottom: 0 }}>
                                            Drag or{" "}
                                            <span style={{ color: "rgba(0, 82, 210, 1)" }}>Upload</span> a file
                                        </p>
                                        <p style={{ fontSize: "12px", fontWeight: 400, textAlign: "center" }}>
                                            JPEG, PNG, PDF AND MP4 FORMATS UP TO 50MB
                                        </p>
                                    </Box>
                                ) : error === "" ? (
                                    <Box sx={{ textAlign: 'center' }}>
                                        <p style={{ fontSize: "16px", fontWeight: 600, marginBottom: '8px' }}>
                                            Drag or{" "}
                                            <span style={{ color: "rgba(131, 141, 144, 1)" }}>Upload</span> a file
                                        </p>
                                        <Box
                                            sx={{
                                                border: "1px solid rgba(29, 113, 52, 1)",
                                                borderRadius: "2px",
                                                bgcolor: "rgba(216, 247, 217, 1)", // light red background
                                                padding: 2,
                                                display: "flex",
                                                justifyContent: "space-between", // left content + right button
                                                alignItems: "center",
                                                width: "335px", // adjust as needed

                                            }}
                                        >
                                            {/* Left content with image before text */}
                                            <Box sx={{ display: "flex", width: 'auto', marginX: '8px' }}>
                                                <img
                                                    src={circlecheck} // replace with your image path
                                                    alt="start icon"
                                                    style={{ width: '20px', height: '20px' }}

                                                />
                                                <Typography sx={{ color: "rgba(29, 113, 52, 1)", fontSize: '14px', fontWeight: '500', textAlign: 'left', paddingLeft: '5px' }}>
                                                    Good to go! Your file is ready to submit!
                                                </Typography>
                                            </Box>

                                            {/* Right button */}
                                        </Box>
                                        <p style={{ fontSize: "12px", fontWeight: 400, textAlign: "center" }}>
                                            JPEG, PNG, PDF AND MP4 FORMATS UP TO 50MB
                                        </p>
                                    </Box>

                                ) : (
                                    <Box sx={{ textAlign: 'center' }}>
                                        <p style={{ fontSize: "16px", fontWeight: 600, marginBottom: '8px' }}>
                                            Drag or{" "}
                                            <span style={{ color: "rgba(131, 141, 144, 1)" }}>Upload</span> a file
                                        </p>
                                        <Box
                                            sx={{
                                                border: "1px solid rgba(220, 25, 25, 1)",
                                                borderRadius: "2px",
                                                bgcolor: "rgba(255, 240, 240, 1)", // light red background
                                                padding: 2,
                                                display: "flex",
                                                justifyContent: "space-between", // left content + right button
                                                alignItems: "center",
                                                width: "335px", // adjust as needed

                                            }}
                                        >
                                            {/* Left content with image before text */}
                                            <Box sx={{ display: "flex", color: "rgba(220, 25, 25, 1)", width: '250px', marginX: '8px' }}>
                                                <img
                                                    src={circle_exclamation} // replace with your image path
                                                    alt="start icon"
                                                    style={{ width: '20px', height: '20px' }}

                                                />
                                                <Typography sx={{ color: "rgba(220, 25, 25, 1)", fontSize: '14px', fontWeight: '500', textAlign: 'left', paddingLeft: '5px' }}>
                                                    {error}
                                                </Typography>
                                            </Box>

                                            {/* Right button */}
                                            <Button
                                                variant="text"
                                                sx={{
                                                    color: "rgba(220, 25, 25, 1)",
                                                    fontWeight: '600',
                                                    fontSize: '14px',
                                                    alignSelf: "flex-start",
                                                    padding: 0,
                                                    margin: 0
                                                }}
                                            >
                                                RETRY
                                            </Button>
                                        </Box>
                                        <p style={{ fontSize: "12px", fontWeight: 400, textAlign: "center" }}>
                                            JPEG, PNG, PDF AND MP4 FORMATS UP TO 50MB
                                        </p>
                                    </Box>
                                )}
                            </div>
                        </LazyFileUploader>
                    </Suspense>
                    {value != null && error === "" && (
                        <Box
                            sx={{
                                display: "flex",
                                height: "auto",
                                flexDirection: "column",
                                paddingY: "20px",
                                gap: "10px",
                            }}
                        >
                            <label>Title</label>
                            <TextField
                                value={title}
                                onChange={(e) => setTitle(e.target.value.slice(0, TITLE_MAX_LENGTH))}
                                onBlur={() => setTitle(title.trim())}
                                size="small"
                                variant="outlined"
                                inputProps={{ maxLength: TITLE_MAX_LENGTH }}
                            />
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography sx={{ fontSize: "12px", color: "#455459" }}>
                                    You can revise this title at any point.
                                </Typography>
                                <Typography sx={{ fontSize: "12px", color: "#455459" }}>
                                    {title.length}/{TITLE_MAX_LENGTH}
                                </Typography>
                            </Box>
                        </Box>)}</>}
                <DialogActions>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mt: '20px' }}>
                        <Button
                            onClick={() => setAttachButton(prevState => !prevState)}
                            sx={{
                                maxHeight: "32px",
                                color: "rgba(7, 27, 34, 1)",
                                borderColor: "rgba(7, 27, 34, 1)",
                                borderRadius: '8px',
                                border: '2px solid rgba(7, 27, 34, 1)',
                                fontWeight: '600',
                                fontSize: '14px',
                                width: '129px',
                                whiteSpace: 'nowrap',
                                mt: '2px'
                            }}
                            startIcon={<BackwardArrow />}
                        >
                            Description
                        </Button>
                        <Button
                            onClick={(e) => handleContinue(e)}
                            sx={{
                                maxHeight: "32px",
                                color: "rgba(238, 242, 253, 1)",
                                borderColor: "rgba(7, 27, 34, 1)",
                                borderRadius: '8px',
                                border: '2px solid rgba(7, 27, 34, 1)',
                                backgroundColor: 'rgba(7, 27, 34, 1)',
                                fontWeight: '600',
                                fontSize: '14px',
                                width: '129px',
                                whiteSpace: 'nowrap',
                                mt: '2px',
                                '&.Mui-disabled': {
                                    opacity: 0.4,
                                    color: 'rgba(238, 242, 253, 1)'
                                },
                            }}
                            disabled={
                                fileURL
                                    ? (!url || !/^https?:\/\/(drive\.google\.com)\/.+$/.test(url))
                                    : (value == null || error !== '')
                            }
                            endIcon={<ForwardArrow />}
                        >
                            Continue
                        </Button>
                    </Box>
                </DialogActions>


            </>}
            {/* First Screen */}
            {(!attachButton && !continueButton) && <>
                <Box sx={{ display: "flex", flexDirection: "column", gap: '5px', paddingY: "10px" }}>
                    <Box sx={{ fontWeight: 600, fontSize: "24px" }}>What will you be showcasing?</Box>
                    <IconButton
                        sx={{ position: "absolute", right: 7, top: 7 }}
                        onClick={(e) => handleLocalClose(e)}
                        onKeyDown={(e) => {
                            if (e.key == 'Escape') {
                                e.preventDefault();
                                handleLocalClose(e)
                            }
                        }}
                    >
                        <img src={closeIcon} height={10} width={10} alt="Close" />
                    </IconButton>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <label htmlFor="type-select" style={{ fontWeight: 400, fontSize: '14px' }}>
                                Type
                            </label>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <FormControl fullWidth>
                                    <Select
                                        id="type-select"
                                        value={types}
                                        onChange={(e) => setTypes(e.target.value)}
                                        displayEmpty
                                        sx={{ width: '384px', height: '40px', backgroundColor: 'rgba(242, 246, 253, 1)' }}
                                    >
                                        <MenuItem value="" disabled>
                                            Select
                                        </MenuItem>
                                        {options.map((option, index) => (
                                            <MenuItem key={index} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={group}
                                            onChange={(e) => setGroup(e.target.checked)}
                                        />
                                    }
                                    label="Group Experience"
                                    sx={{
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: '14px',
                                            fontWeight: 400,
                                            whiteSpace: 'nowrap'

                                        },
                                    }}
                                />
                            </Box>

                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', mt: '15px', gap: 1 }}>
                            <label style={{ fontWeight: 500, fontSize: '14px' }}>Description</label>
                            <TextField
                                size="medium"
                                value={desc}
                                onChange={(e) => setDesc(e.target.value.slice(0, TITLE_MAX_LENGTH))}
                                onBlur={() => setDesc(desc.trim())}
                                onPaste={(e) => {
                                    e.preventDefault();
                                    const paste = e.clipboardData.getData('text');
                                    const target = e.target as HTMLTextAreaElement;
                                    const start = target.selectionStart || 0;
                                    const end = target.selectionEnd || 0;
                                    const newValue = (desc.slice(0, start) + paste + desc.slice(end)).slice(0, TITLE_MAX_LENGTH);
                                    setDesc(newValue);
                                }}
                                variant="outlined"
                                placeholder="For example:  This is a video of my persuasive speech from English class."
                                multiline
                                maxRows={3}
                                inputProps={{
                                    maxLength: TITLE_MAX_LENGTH, sx: {
                                        '&::placeholder': {
                                            fontStyle: 'italic',
                                        },
                                    },
                                }}
                                sx={{
                                    backgroundColor: 'rgba(242, 246, 253, 1)',
                                    height: '82.5px',

                                    // This targets the input wrapper
                                    '& .MuiInputBase-root': {
                                        height: '100%',
                                    },

                                    // This targets the actual textarea
                                    '& .MuiInputBase-inputMultiline': {
                                        // padding: '12px',      // Optional: control padding
                                        height: '100%',
                                        boxSizing: 'border-box',
                                        overflow: 'auto',
                                    },
                                }}
                            />
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography sx={{ fontSize: "12px", color: "#455459", mt: '6px' }}>
                                You can add to or change this description at any point.
                            </Typography>
                            <Typography sx={{ fontSize: "12px", color: "#455459", mt: '6px' }}>
                                {desc.length}/{TITLE_MAX_LENGTH}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <DialogActions>
                    <Button
                        onClick={() => setAttachButton(prevState => !prevState)}
                        sx={{
                            maxHeight: "32px",
                            color: "rgba(238, 242, 253, 1)",
                            borderColor: "rgba(7, 27, 34, 1)",
                            borderRadius: '8px',
                            border: '2px solid rgba(7, 27, 34, 1)',
                            backgroundColor: 'rgba(7, 27, 34, 1)',
                            fontWeight: '600',
                            fontSize: '14px',
                            width: '129px',
                            whiteSpace: 'nowrap',
                            mt: '2px'
                        }}
                        endIcon={<ForwardArrow />}
                    >
                        Attach file
                    </Button>
                </DialogActions>
            </>}

        </Dialog>
    );
};

export default AddArtifactDialog;
